export default __webpack_public_path__ + "static/media/People-illustration.ffc983ed.png";